// extracted by mini-css-extract-plugin
export var buttons = "inputPrefix-module--buttons--HOWEB";
export var inputWrapper = "inputPrefix-module--inputWrapper--E1YMT";
export var prefix = "inputPrefix-module--prefix--XxhE+";
export var root = "inputPrefix-module--root--t068H";
export var thumbnail = "inputPrefix-module--thumbnail--o-M6m";
export var thumbnailWrapper = "inputPrefix-module--thumbnailWrapper--PlLm6";
export var title = "inputPrefix-module--title--zXXFu";
export var titleIcon = "inputPrefix-module--titleIcon--iMMQz";